// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CreateOtherSubjectBinding, CreateOtherSubjectBindingSchema } from 'api/gen/CreateOtherSubjectBinding';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateOtherSubjectBindingAdminBaseObject, ValidateOtherSubjectBindingAdminBaseObjectSchema } from 'api/gen/ValidateOtherSubjectBindingAdminBaseObject';

const requiredPart = t.interface({
  tag: t.literal('ValidateCreateOtherSubjectBindingAdmin'),
  binding: t.union([CreateOtherSubjectBindingSchema, t.null]),
});

export const ValidateCreateOtherSubjectBindingAdminSchema = excess(t.intersection([ValidateOtherSubjectBindingAdminBaseObjectSchema.type, requiredPart]));

export interface ValidateCreateOtherSubjectBindingAdmin extends t.TypeOf<typeof ValidateCreateOtherSubjectBindingAdminSchema> {}
